import React from "react";
import "./EventManageCardsFullCardsTable.css"; // Import the custom CSS file
import ScorecardSummaryTableStickyHeader from "./ScorecardSummaryTableStickyHeader";
import ScorecardSummaryTableStickyRow from "./ScorecardSummaryTableStickyRow";

function EventManageCardsFullCardsTable({ card, throwScoringModeId }) {
  const maxHole =
    card.group_scorecard_players[0].event_entries.hole_scores.length;

  return (
    <div className="table-wrapper">
      <table className="table-sm w-100" style={{ background: "#FFFFFF" }}>
        <thead>
          <ScorecardSummaryTableStickyHeader
            throwScoringModeId={throwScoringModeId}
            maxHole={maxHole}
            managePage={true}
          />
        </thead>
        <tbody>
          {card.group_scorecard_players.map((player, index) => (
            <ScorecardSummaryTableStickyRow
              player={player}
              index={index}
              throwScoringModeId={throwScoringModeId}
              key={index}
              small={true}
              managePage={true}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default EventManageCardsFullCardsTable;
